import FulfillmentScreen from './index';
import CreateScreen from './create';
import DetailScreen from './detail';
import UpdateScreen from './update';

const routes = [
  {
    path: '/delivery/fulfillment',
    component: FulfillmentScreen,
  },
  {
    path: '/delivery/fulfillment/create',
    component: CreateScreen,
  },
  {
    path: '/delivery/fulfillment/:id',
    component: DetailScreen,
  },
  {
    path: '/delivery/fulfillment/:id/update',
    component: UpdateScreen,
  },
];

export default routes;
